// extracted by mini-css-extract-plugin
export default {"mainDiv":"categories_mainDiv__qQ4XZ"};